export interface EmployeeTypeClass{
    AccountEmployeeTypeId: string
    AccountEmployeeType: string
    IsVendor:boolean
    AccountId: number
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    IsDeleted: boolean
    IsDisabled: boolean
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    isSelected:number
}


const common = {    
    AccountEmployeeType: "",
    IsVendor:false,
    IsDisabled:false
  };
  
  export const employeeTypeInitialsForAdd = { ...common };
  
  export const employeeTypeInitialsForUpdate = {
    ...common,
    AccountEmployeeTypeId: ""
  };
  

// export const employeeTypeInitialsForApp = {
//     AccountEmployeeType: "",
//     IsVendor:false,
//     IsDisabled:false
// }

// export const employeeTypeInitialsForUpdate = {
//     AccountEmployeeTypeId: "",
//     AccountEmployeeType: "",
//     IsVendor:false,
//     IsDisabled:false

// }